function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function mitt(n){return {all:n=n||new Map,on:function(t,e){var i=n.get(t);i?i.push(e):n.set(t,[e]);},off:function(t,e){var i=n.get(t);i&&(e?i.splice(i.indexOf(e)>>>0,1):n.set(t,[]));},emit:function(t,e){var i=n.get(t);i&&i.slice().map(function(n){n(e);}),(i=n.get("*"))&&i.slice().map(function(n){n(t,e);});}}}

class IntercomPlugin {
  constructor(appId) {
    _defineProperty(this, "emitter", mitt());

    _defineProperty(this, "isReady", false);

    _defineProperty(this, "isVisible", false);

    _defineProperty(this, "unreadCount", 0);

    _defineProperty(this, "onIsReady", callback => this.emitter.on('ready', callback));

    this.appId = appId;

    if (document.readyState === 'complete') {
      this.loadScript(appId);
    } else if (window.attachEvent) {
      window.attachEvent('onload', () => this.loadScript(appId));
    } else {
      window.addEventListener('load', () => this.loadScript(appId), false);
    }
  }

  loadScript(appId) {
    var _firstScript$parentNo;

    const script = document.createElement('script');
    script.async = true;
    script.src = `https://widget.intercom.io/widget/${appId}`;
    const firstScript = document.getElementsByTagName('script')[0];
    (_firstScript$parentNo = firstScript.parentNode) === null || _firstScript$parentNo === void 0 ? void 0 : _firstScript$parentNo.insertBefore(script, firstScript);

    script.onload = () => {
      this.isReady = true;
      this.emitter.emit('ready');
      window.Intercom('onHide', () => this.isVisible = false);
      window.Intercom('onShow', () => this.isVisible = true);
      window.Intercom('onUnreadCountChange', unreadCount => this.unreadCount = unreadCount);
    };
  }

  boot(options = {
    app_id: this.appId
  }) {
    window.Intercom('boot', options);
  }

  shutdown() {
    window.Intercom('shutdown');
  }

  update(...options) {
    window.Intercom('update', ...options);
  }

  show() {
    window.Intercom('show');
  }

  hide() {
    window.Intercom('hide');
  }

  showMessages() {
    window.Intercom('showMessages');
  }

  trackEvent(name, ...metadata) {
    window.Intercom('trackEvent', ...[name, ...metadata]);
  }

  getVisitorId() {
    window.Intercom('getVisitorId');
  }

}

const intercomKey = Symbol('Intercom injection key');

const install = function installVue3Intercom(app, {
  appId
}) {
  const plugin = new IntercomPlugin(appId);
  app.config.globalProperties.$intercom = plugin;
  app.provide(intercomKey, plugin);
}; // Create module definition for app.use()

export { install as default };
